import { ShowDocumentModalForm } from "./ShowDocumentModalForm"


const ShowDocumentModalFormWrapper = () => {
    return (<ShowDocumentModalForm />)
}

export {ShowDocumentModalFormWrapper}